import React from "react";
import AboutView from "../components/About/AboutView";
import usePageMeta from "../hooks/usePageMeta";

function About() {
  usePageMeta(
    "About Us | Jhatka Byte – Black Bengal Jhatka Mutton",
    "Learn about Jhatka Byte, suppliers of fresh Black Bengal jhatka mutton in Kolkata, Barrackpur and Bardhaman."
  );
  return <AboutView />;
}

export default About;
